import { Component, EventEmitter, Output, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { EmitterService } from '../../services/emitter.service';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { environment } from "../../../environments/environment";
import { Utility } from '../../shared/utility/utility';


@Component({
  selector: 'app-reg-goback',
  templateUrl: './app-reg-goback.component.html',
  styleUrls: ['./app-reg-goback.component.scss']
})
export class AppRegGobackComponent implements OnDestroy {
  langCode;
  destroy$: Subject<boolean> = new Subject<boolean>();
  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaPath = environment.mediaPath;
  websiteName = environment.website_name;

  @Output() continueRegistration = new EventEmitter<string>();


  constructor(
    private emitterService: EmitterService,
    private router: Router,
    private utils:Utility
  ) {

    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(lang => {
      this.langCode = lang;
    });
   }

  cancelReg(){
    this.utils.disablescrollOnRegistrationPageOpend();
    this.emitterService.broadcastRouteChange(false);
    this.router.navigate([this.langCode]);
  }

  continueReg(){
    this.continueRegistration.emit('true');
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
